/* globals lp,Class */
var StylesheetModule = Class.create(
  lp.ModuleBase,
  lp.ModuleElementMethods,
  lp.ModuleElementBuilderMethods,
  {
    beforeCreate: function(page, defaults, options, data) {
      defaults.content.html = data.html;
    }
  }
);

lp.addModule(new StylesheetModule(
  {
    type:'lp-stylesheet',
    version:'1.0',
    name: 'Stylesheet',
    defaultName: 'Stylesheet',
    usageType:'non-visible-page-widget',
    namespace: lp.module.stylesheet
  }
));

module.export = StylesheetModule;



//////////////////
// WEBPACK FOOTER
// ./src/legacy/lp/modules/lp-stylesheet/stylesheet_module.js
// module id = 587
// module chunks = 0 1